export const CreditBureauProvider = {
  TRANS_UNION: 'TRANS_UNION',
  EQUIFAX: 'EQUIFAX',
  EXPERIAN: 'EXPERIAN',
};

export const CreditBureauProviderCamelCase = {
  TRANS_UNION: 'TransUnion',
  EQUIFAX: 'Equifax',
  EXPERIAN: 'Experian',
};

/**
 * The option list for users who enrolled in credit builder and rent reporting
 * #1 in the list for Rent Reporting
 * #2 in the list for Credit Builder
 */
export const PaymentHistoryCardListForPremium = [
  {
    cardTitle: 'Premium',
    title: 'Rent Reporting',
    content:
      'Reporting on-time rent payments to credit bureaus helps tenants build credit history and improve credit scores.',
    linkPath: '/rentPaymentReportingHome',
  },
  {
    cardTitle: 'Premium',
    title: 'Credit Builder',
    content:
      'Sign up for Credit Builder and use debit to build credit history with a pre-paid Sesame Cash debit card.',
    linkPath: '/cash',
  },
];
